import React, { useState, useEffect, useContext } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Typography from "@mui/material/Typography";
import styles from "./styles.module.css";
import logo from "../../images/logoBrancoPrincipal.png";
import Link from "@mui/material/Link";
import LogoutIcon from "@mui/icons-material/Logout";
import { ItemsMenu, NomeCompleto } from "../../utils/localStorage.util";
import { ajustarMenusPortal } from "../../utils/menusConciliacao.util";

import { Context } from "../../config/AuthContext";
import { useNavigate } from "react-router-dom";

import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function PersistentDrawerLeft() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    // localStorage.removeItem('reload') ;
  }, []);

  const { handleLogout } = useContext(Context);
  const navigate = useNavigate();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [menuItems, setMenuItems] = useState([]);

  const [openMenus, setOpenMenus] = useState([]);
  useEffect(() => {
    const storedMenus = ItemsMenu.getItemsMenu();
    if (storedMenus) {
      const parsedMenus = ajustarMenusPortal(JSON.parse(storedMenus));
      setMenuItems(parsedMenus);
    }
  }, []);

  const handleMenuClick = (menuId) => {
    if (openMenus.includes(menuId)) {
      setOpenMenus(openMenus.filter((id) => id !== menuId));
    } else {
      setOpenMenus([...openMenus, menuId]);
    }
  };

  const handleSubmenuClick = (submenu) => {
    if (submenu.targetBlank) {
      window.open(submenu.href, "_blank");
    } else {
      navigate(submenu.href);
    }
  };

  const logout = () => {
    handleLogout();
    navigate("/");
  };

  const toDashboard = () => {
    navigate("/dashboard");
  };

  const renderSubmenus = (submenus) => (
    <List>
      {submenus.map((submenu) => (
        <ListItem key={submenu.idSubMenu} disablePadding>
          <ListItemButton onClick={() => handleSubmenuClick(submenu)}>
            <ListItemText primary={submenu.submenu} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );

  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="fixed" open={open}>
          <Toolbar
            className={styles.menuPrincipal}
            sx={{
              display: "grid",
              gridGap: 20,
              ...(open && { gridTemplateColumns: "repeat(2, 1fr)" }),
              ...(!open && { gridTemplateColumns: "repeat(3, 1fr)" }),
            }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              sx={{
                mr: 2,
                justifySelf: "flex-start",
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Box
              sx={{
                display: "flex",
                ...(!open && { justifyContent: "center" }),
              }}
            >
              <Link component="button" onClick={toDashboard}>
                <img src={logo} className={styles.logoMenu} alt="Logo"></img>
              </Link>
            </Box>
            <Box
              sx={{
                display: "inline-flex",
                gap: "20px",
                justifySelf: "flex-end",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography className={styles.textoCabecalho}>
                Bem-vindo(a), {NomeCompleto.getNomeCompleto()}!
              </Typography>
              <IconButton color="inherit" onClick={logout}>
                <LogoutIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          <DrawerHeader
            className={styles.cabecalhoMenuSecoes}
            sx={{
              paddingLeft: "16px",
              justifyContent: "space-between",
            }}
          >
            <Typography sx={{ fontWeight: "bold" }}>Menus</Typography>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon className={styles.iconeCabecalhoMenuSecoes} />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List>
            {menuItems.map((menuItem) => (
              <div key={menuItem.idMenu}>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => handleMenuClick(menuItem.idMenu)}
                  >
                    <ListItemText
                      primary={menuItem.menu}
                      primaryTypographyProps={{
                        fontWeight: "bold",
                      }}
                    />
                    {openMenus.includes(menuItem.idMenu) ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItemButton>
                </ListItem>
                <Collapse
                  in={openMenus.includes(menuItem.idMenu)}
                  timeout="auto"
                  unmountOnExit
                >
                  {renderSubmenus(menuItem.submenu)}
                </Collapse>
              </div>
            ))}
          </List>
        </Drawer>
        <Main open={open}>
          <DrawerHeader />
        </Main>
      </Box>
    </div>
  );
}
